import { providerTypes } from 'constants/providerTypes';

export const getDoctorsListForDropDown = (doctorsList, searchList) => {
  const list = [];
  if (doctorsList?.length) {
    doctorsList.forEach(item => {
      const {
        AccountKey,
        BranchKey,
        BranchName,
        DoctorNameEnglish,
        EntityKey,
        ImageUrl,
        MainSpecialtyNameEnglish,
        MainSpecialityKey,
        TopLevelEntityName,
        ExaminationRoomKey,
      } = item;

      const searchedIndex = searchList?.findIndex(
        itemObj =>
          `${itemObj.AccountKey}-${itemObj.ExaminationRoomKey}` ===
          `${AccountKey}-${ExaminationRoomKey}`,
      );

      list.push({
        isSelected: searchedIndex !== -1,
        fieldValue: `${DoctorNameEnglish}${TopLevelEntityName ? ` - ${TopLevelEntityName}` : ''}`,
        itemImage: ImageUrl,
        value: AccountKey,
        description: MainSpecialtyNameEnglish,
        key: AccountKey,
        extras: {
          AccountKey,
          BranchKey,
          BranchName,
          DoctorNameEnglish,
          EntityKey,
          ImageUrl,
          MainSpecialtyNameEnglish,
          MainSpecialityKey,
          TopLevelEntityName,
          ExaminationRoomKey,
        },
      });
    });
  }
  return list;
};

export const buildProvidersBulkPayload = (priceListId, selectedProviders) => {
  const providers = [];
  selectedProviders?.forEach(providerItem => {
    const { DoctorNameEnglish, ImageUrl, MainSpecialityKey, branches } = providerItem;
    branches?.forEach(branch => {
      const { isChecked, roomKey, areaKey, entityKey, isExclusive: branchExclusive } = branch;
      if (isChecked) {
        providers.push({
          entityKey,
          providerKey: roomKey,
          providerName: DoctorNameEnglish,
          providerPhoto: ImageUrl,
          specialityKey: MainSpecialityKey,
          areaKey,
          exclusive: branchExclusive,
          spoc: branch.isSpoke,
        });
      }
    });
  });

  return {
    priceListId: Number(priceListId),
    providerTypeId: providerTypes.DOCTOR_CONSULTAION,
    providers,
  };
};
